class JerseyCustomization extends HTMLElement {
    constructor() {
        super();
        this.fieldset = this.querySelector('[data-jersey-customization-fieldset]');
        this.fieldsContainer = this.querySelector('[data-jersey-customization-fields]');
        this.nameInput = this.querySelector('[data-jersey-customization-name]');
        this.numberInput = this.querySelector('[data-jersey-customization-number]');
        this.headerOption = this.fieldset?.querySelector('[data-header-option]') || this.fieldset?.querySelector('.label-value-customization');
        this.yesRadio = this.querySelector('input[name="jersey_customization"][value="yes"]');

        if (this.fieldset) {
            this.fieldset.addEventListener('change', this.onChange.bind(this));
        }
    }

    onChange(evt) {
        if (evt.target.name !== 'jersey_customization') return;
        const selected = this.fieldset.querySelector('input[name="jersey_customization"]:checked');
        if (!selected) return;

        const isAdd = selected.value === 'yes';

        if (this.fieldsContainer) {
            this.fieldsContainer.style.display = isAdd ? '' : 'none';
        }

        if (this.nameInput) {
            this.nameInput.required = isAdd;
        }
        if (this.numberInput) {
            this.numberInput.required = isAdd;
        }

        if (this.headerOption) {
            this.headerOption.textContent = isAdd ? 'Add Name & Number' : 'No Name & Number';
        }

        // Update displayed price
        if (typeof window.updateAddonPrice === 'function') {
            window.updateAddonPrice();
        }
    }

    getCustomizationPrice() {
        if (!this.yesRadio) return 0;
        const checked = this.fieldset.querySelector('input[name="jersey_customization"]:checked');
        if (!checked || checked.value !== 'yes') return 0;
        const priceStr = this.yesRadio.getAttribute('data-customization-price');
        return parseInt(priceStr) || 0;
    }

    isActive() {
        const checked = this.fieldset.querySelector('input[name="jersey_customization"]:checked');
        return checked && checked.value === 'yes';
    }
}

customElements.define('jersey-customization', JerseyCustomization);

// Global price adjustment: customization only
// Patches (1/2/3) are part of the variant selection, so their price is
// already included in the variant price. Only the customization product
// (Name & Number, +Rs. 600) is added as an extra add-on.
window.updateAddonPrice = function() {
    var priceContainer = document.querySelector('.productView-product .price') || document.querySelector('.productView-price .price');
    if (!priceContainer) return;

    var priceLastEl = priceContainer.querySelector('.price__sale .price__last') || priceContainer.querySelector('.price__regular .price__last');
    var priceRegularEl = priceContainer.querySelector('.price__regular .price-item--regular');
    var priceSaleEl = priceContainer.querySelector('.price__sale .price-item--sale');

    // Store original variant price on first call
    if (!priceContainer.hasAttribute('data-base-price')) {
        var lastEl = priceContainer.querySelector('.price__sale .price__last') || priceContainer.querySelector('.price__regular .price__last');
        if (lastEl) {
            var basePrice = lastEl.getAttribute('data-last');
            if (basePrice) priceContainer.setAttribute('data-base-price', basePrice);
        }
    }

    var basePrice = parseInt(priceContainer.getAttribute('data-base-price')) || 0;
    if (!basePrice) return;

    // Only customization add-on (+Rs. 600 = 60000 cents)
    // Patches are already part of the variant price
    var addonTotal = 0;

    var customizationEl = document.querySelector('[data-jersey-customization]');
    if (customizationEl) {
        var checked = customizationEl.querySelector('input[name="jersey_customization"]:checked');
        if (checked && checked.value === 'yes') {
            var yesRadio = customizationEl.querySelector('input[name="jersey_customization"][value="yes"]');
            var cPrice = parseInt(yesRadio.getAttribute('data-customization-price')) || 0;
            // Fallback to Rs. 600 (60000 cents) if product price is 0
            if (cPrice === 0) cPrice = 60000;
            addonTotal += cPrice;
        }
    }

    var newPrice = basePrice + addonTotal;

    // Format using Shopify's money formatter (same as rest of theme)
    var formattedPrice = '';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && window.money_format) {
        formattedPrice = Shopify.formatMoney(newPrice, window.money_format);
    } else {
        formattedPrice = 'Rs. ' + (newPrice / 100).toFixed(2);
    }

    // Update regular price
    if (priceRegularEl) {
        priceRegularEl.innerHTML = formattedPrice;
    }
    // Update sale price
    if (priceSaleEl) {
        priceSaleEl.innerHTML = formattedPrice;
    }
    // Update data-last attribute
    if (priceLastEl) {
        priceLastEl.setAttribute('data-last', newPrice);
    }

    // Update quantity input data-price so subtotal includes add-ons
    var qtyInput = document.querySelector('input[name="quantity"][data-price]');
    if (qtyInput) {
        qtyInput.setAttribute('data-price', newPrice);
        // Trigger subtotal recalculation
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Also update subtotal directly
    if (window.subtotal && window.subtotal.show) {
        var qty = parseInt(qtyInput?.value) || 1;
        var subTotal = qty * newPrice;
        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            subTotal = Shopify.formatMoney(subTotal, window.money_format);
            subTotal = extractContent(subTotal);
        }
        var pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
        if (pdView_subTotal) {
            pdView_subTotal.textContent = subTotal;
        }
        // Update sticky add-to-cart price
        var stickyPrice = document.querySelector('[data-sticky-add-to-cart] .money-subtotal .money');
        if (stickyPrice) {
            stickyPrice.textContent = subTotal;
        }
    }
};

// Re-run price adjustment after variant changes
// When the variant changes (including patch count), the new variant price
// already includes the patch cost. We just need to re-apply the customization
// add-on if "Add Name & Number" is selected.
document.addEventListener('variant:changed', function() {
    setTimeout(function() {
        // Reset base price from the newly rendered price (pure variant price)
        var priceContainer = document.querySelector('.productView-product .price') || document.querySelector('.productView-price .price');
        if (priceContainer) {
            var lastEl = priceContainer.querySelector('.price__sale .price__last') || priceContainer.querySelector('.price__regular .price__last');
            if (lastEl) {
                var basePrice = lastEl.getAttribute('data-last');
                if (basePrice) {
                    priceContainer.setAttribute('data-base-price', basePrice);
                }
            }
        }
        if (typeof window.updateAddonPrice === 'function') {
            window.updateAddonPrice();
        }
    }, 100);
});
